// src/admin/AdminLayout.js
import React from 'react';
import { Outlet, Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PeopleIcon from '@mui/icons-material/People';
import InventoryIcon from '@mui/icons-material/Inventory';
import StarIcon from '@mui/icons-material/Star';
import SmartToyIcon from '@mui/icons-material/SmartToy'; // <-- Import Bot icon
import Divider from '@mui/material/Divider';
import FeedbackIcon from '@mui/icons-material/Feedback'; // <-- Import Feedback icon

const drawerWidth = 240;

function AdminLayout() {
    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <Toolbar>
                    <Typography variant="h6" noWrap component="div">
                        Admin Panel
                    </Typography>
                </Toolbar>
                <Divider />
                <List>
                    <ListItem disablePadding component={RouterLink} to="/admin/users" sx={{ color: 'inherit', textDecoration: 'none' }}>
                        <ListItemButton>
                            <ListItemIcon><PeopleIcon /></ListItemIcon>
                            <ListItemText primary="Users" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding component={RouterLink} to="/admin/items" sx={{ color: 'inherit', textDecoration: 'none' }}>
                        <ListItemButton>
                            <ListItemIcon><InventoryIcon /></ListItemIcon>
                            <ListItemText primary="Items" />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding component={RouterLink} to="/admin/featured-items" sx={{ color: 'inherit', textDecoration: 'none' }}>
                        <ListItemButton>
                            <ListItemIcon><StarIcon /></ListItemIcon>
                            <ListItemText primary="Featured Items" />
                        </ListItemButton>
                    </ListItem>
                    {/* --- START: Add Bot Management Link --- */}
                    <ListItem disablePadding component={RouterLink} to="/admin/bots" sx={{ color: 'inherit', textDecoration: 'none' }}>
                        <ListItemButton>
                            <ListItemIcon><SmartToyIcon /></ListItemIcon>
                            <ListItemText primary="Bots" />
                        </ListItemButton>
                    </ListItem>
                    {/* --- END: Add Bot Management Link --- */}
                    <ListItem disablePadding component={RouterLink} to="/admin/offer-feedback" sx={{ color: 'inherit', textDecoration: 'none' }}>
                        <ListItemButton>
                            <ListItemIcon><FeedbackIcon /></ListItemIcon>
                            <ListItemText primary="Offer Feedback" />
                        </ListItemButton>
                    </ListItem>
                    {/* Add more admin links here */}
                </List>
            </Drawer>
            <Box
                component="main"
                sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
            >
                {/* Toolbar offset might be needed if you have a top AppBar */}
                {/* <Toolbar />  */}
                <Outlet /> {/* Child routes will render here */}
            </Box>
        </Box>
    );
}

export default AdminLayout;
